export { ReportingCurrencies } from './reportingCurrencies.component';
